import type { IconSvgObject } from './types';

const YenSendIcon: IconSvgObject = [
  ["path", { d: "M19 14.5L21.5 12L19 9.5M15 12H20.8912", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.5 4L8 10.6111M8 10.6111L13.5 4M8 10.6111V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5.5 13.5H10.5M5.5 16.5H10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default YenSendIcon;
